import { useMemo } from 'react';
var statusIcons = ['check-circle', 'exclamation-circle', 'exclamation-triangle'];
export function useInputStatus(success, error, warning) {
  return useMemo(function () {
    var result = {
      icon: null,
      ref: null
    };
    var statuses = [success, error, warning];
    for (var i = 0; i < statuses.length; i++) {
      if (!statuses[i]) {
        continue;
      }
      result.icon = statusIcons[i];
      if (typeof statuses[i] === 'function') {
        result.ref = statuses[i];
      }
    }
    return result;
  }, [success, error, warning]);
}